module.exports = __webpack_public_path__ + "static/Corprate_WhoWeAre_03-f0a6e20b1743a0fa94d666428c970dd0.jpg";